<template>
  <label
    v-if="sortOptions?.length && sortOptions.length > 1"
    class="sort"
  >
    <span
      class="sort__label"
    >{{ $t('Sort by') }}</span>

    <select
      class="sort__select"
      @input="(event) => $emit('updateSort', (event.target as HTMLInputElement).value)"
    >
      <option
        v-for="option in sortOptions"
        :key="`sort-${option.title}`"
        :value="option.title"
        :selected="option.isselected"
      >
        {{ option.displaytitle }}
      </option>
    </select>
  </label>
</template>

<script setup lang="ts">
defineProps<{
  sortOptions: any[]
}>()

defineEmits(['updateSort'])
</script>

<style>
@import url("~layers/app/components/Paginator/Sort.css");
</style>
